import React, { useContext } from "react";
import classNames from "classnames";

import { toDisplayOdd } from "@gp/utility";
import { BetBuilderModeContext } from "@state/context/bet-builder/BetBuilderModeContext";

export default function OfferTipButton(props: {
	/** @default true */
	hasMargin?: boolean;
	isPlayerMarket?: boolean;
	isAdditionalOffer?: boolean;
	value: string | number;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	isLocked?: boolean;
	isOneClickBetActive?: boolean;
	isSelected?: boolean;
	indicator?: -1 | 0 | 1;
	displayTipName?: string | null;
	label?: string | null;
	nextOddsOff: boolean;
	isBetBuilderTipSelected: boolean;
	isBetBuilderTipHidden: boolean;
}) {
	const hasMargin = props.hasMargin != null ? props.hasMargin : true;
	const displayTipValue = toDisplayOdd(props.value);
	const isBetBuilderTab = useContext(BetBuilderModeContext);

	if (displayTipValue == null) {
		return null;
	}

	const tipLabelClasses = classNames("quote quote--margin", {
		"u-type--left": hasMargin,
		offer__player__tip: props.isPlayerMarket,
		"offer--additional__margin": props.isAdditionalOffer,
	});

	return (
		<>
			{props.displayTipName != null ? (
				<div className={tipLabelClasses} title={props.label || ""}>
					{props.label}
				</div>
			) : null}

			<button
				type="button"
				title={displayTipValue}
				onClick={props.onClick}
				disabled={props.isLocked || props.isBetBuilderTipHidden}
				className={classNames("quote quote--button", {
					"one-click": props.isOneClickBetActive,
					"quote--bb--button": isBetBuilderTab,
					"is-active": props.isSelected,
					// "u-color--text--primary": props.displayTipName,
					desc: props.indicator === -1,
					inc: props.indicator === 1,
					"is-next-odds-off": !props.nextOddsOff,
				})}
			>
				{props.nextOddsOff ? (
					displayTipValue
				) : (
					<React.Fragment>
						{props.isBetBuilderTipSelected ? (
							<i className="u-icon u-icon--sml u-icon--check u-color--core--snow u-icon--animated--bounce-in" />
						) : props.isBetBuilderTipHidden && !props.isLocked ? (
							<i className="u-icon u-icon--sml u-icon--lock u-color--text--tertiary u-icon--animated--bounce-in" />
						) : (
							displayTipValue
						)}
					</React.Fragment>
				)}
			</button>
		</>
	);
}
